import script from "./ModalManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalManager.vue?vue&type=script&setup=true&lang=ts"

import "./ModalManager.vue?vue&type=style&index=0&id=84c83104&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84c83104"]])

export default __exports__